import PropTypes from "prop-types"

export const SUB_LINK = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
})

export const LINK = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  Icon: PropTypes.elementType,
  to: PropTypes.string.isRequired,
  subItems: PropTypes.arrayOf(SUB_LINK),
  openInNewTab: PropTypes.bool,
})

export const CONTROLS = PropTypes.objectOf(
  PropTypes.bool,
)

export const PORTFOLIO = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  // The model id — short and distinguishing. `modelName` is the full name, shown as a tooltip.
  model: PropTypes.string.isRequired,
  modelName: PropTypes.string,
  to: PropTypes.string.isRequired,
})
